/**
 * Emoji reactions — the one lever (PR-4, 2026-09-09). Build-time:
 * `REACT_APP_MESSAGE_REACTIONS=off` hides the trigger, the picker and the
 * chips (the store listener stands down too); anything else = on. The
 * server-side signal (the reaction bracket in Prest0n's context) and the
 * memory-candidate trigger are functions-side and have their own one-flip
 * levers.
 */
export function messageReactionsEnabled(env: Record<string, string | undefined> = process.env): boolean {
  return String(env.REACT_APP_MESSAGE_REACTIONS ?? '').trim().toLowerCase() !== 'off';
}
